import { useMemo } from 'react';
import { VideoStates } from '@msi-alta/opvideo-state-machine';

import { EntryUnlockButton } from 'containers/EntryUnlockButton';

import { WebRtcButton, MicrophoneToggleButton } from '../components';
import VideoDownloadButton from '../components/VideoDownloadButton';

export const useUpperControlsContent = ({
  controls,
  opvideoIntercomId,
  currentVideoState,
  isClip,
  intercomCallButtonClick,
  micPermission,
  isLive,
  cameraId,
  handleMicState,
  isMicEnabled,
  startDate,
  endDate,
  orgId,
  opvideoDeviceId,
}) => {
  return useMemo(() => {
    /*
      We are linking upper and lower controls together so we don't want
      to show the upper controls if controls is set to false
    */
    if (!controls) return null;

    return {
      ...(!!opvideoIntercomId &&
        (currentVideoState === VideoStates.PREVIEW ||
          currentVideoState === VideoStates.SURVEILLANCE ||
          currentVideoState === VideoStates.CALL) &&
        !isClip && {
          center: {
            isPersisted: true,
            content: (
              <WebRtcButton
                onClick={intercomCallButtonClick}
                micPermission={micPermission}
              />
            ),
            style: { flex: 0, padding: '0 11px' },
          },
        }),

      ...((currentVideoState === VideoStates.PREVIEW ||
        currentVideoState === VideoStates.SURVEILLANCE ||
        currentVideoState === VideoStates.CALL ||
        (isLive && !!cameraId) ||
        !isLive) && {
        right: {
          isPersisted: isLive,
          content: (
            <>
              {currentVideoState === VideoStates.CALL && (
                <MicrophoneToggleButton
                  toggleHandler={handleMicState}
                  initState={isMicEnabled()}
                />
              )}
              {isLive && Boolean(cameraId) && (
                <EntryUnlockButton cameraId={cameraId} />
              )}
              {!isLive && startDate && endDate && (
                <VideoDownloadButton
                  orgId={orgId}
                  opvideoDeviceId={opvideoDeviceId}
                  startDate={startDate}
                  endDate={endDate}
                />
              )}
            </>
          ),
        },
      }),
    };
  }, [
    controls,
    opvideoIntercomId,
    currentVideoState,
    isClip,
    intercomCallButtonClick,
    micPermission,
    isLive,
    cameraId,
    handleMicState,
    isMicEnabled,
    startDate,
    endDate,
    orgId,
    opvideoDeviceId,
  ]);
};
